import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { B, Paragraph } from '../../../elements/typography/index.js'
import { formatPrice } from '../../subscriptions/helpers.js'
import messages from '../messages.js'

const PlanDescription = styled(Paragraph)`
  align-content: center;
  text-align: center;
  margin: ${(props) => props.theme.spacing.medium}px 0;
`

export const ChosenPlanDescription = ({ chosenPlan }) => (
  <PlanDescription>
    {chosenPlan?.hasFreeTrial ? (
      <>
        <FormattedMessage
          {...messages.youveChosenOurPlan}
          values={{ plan: <B>{chosenPlan.title}</B> }}
        />
        {'\n'}
        <FormattedMessage {...messages.youveChosenPlanWithTrial} />
      </>
    ) : (
      <>
        <FormattedMessage
          {...messages.youveChosenOurPlan}
          values={{ plan: <B>{chosenPlan.title}</B> }}
        />
        {'\n'}
        <FormattedMessage
          {...messages.youveChosenPlanWithPayment}
          values={{ amount: formatPrice(chosenPlan) }}
        />
      </>
    )}
  </PlanDescription>
)
